<p-dialog
    header="{{ serverHeader }}"
    [(visible)]="displayAddEditServer"
    [modal]="true"
    [responsive]="true"
    [style]="{ width: '55vw' }"
    (onHide)="onDialogClose()"
>
    <form [formGroup]="smtpFb">
        <div class="header">
            <h5>
                Server Information
                <!-- <p-inputSwitch
                    class="header-switch"
                    [(ngModel)]="serverTemp.isActive"
                ></p-inputSwitch> -->
            </h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>SMTP Server <span style="color: red">*</span></label>
                    <input
                        type="text"
                        pInputText
                        placeholder="Enter SMTP Server"
                        formControlName="serverName"
                    />
                </div>
                <!-- <div class="p-col-12 p-md-6" *ngIf="showOthers">
                    <label>Username <span style="color: red">*</span></label>
                    <input
                        type="text"
                        pInputText
                        placeholder="Enter Username"
                        formControlName="userName"
                    />
                </div> -->
                <div class="p-col-4 p-md-2">
                    <label>Port</label>
                    <input
                        type="text"
                        pInputText
                        placeholder="Enter Port"
                        formControlName="serverPortOut"
                    />
                </div>
                <div class="p-col-8 p-md-4" *ngIf="!showOthers">
                    <label>Username <span style="color: red">*</span></label>
                    <input
                        type="text"
                        pInputText
                        placeholder="Enter Username"
                        formControlName="userName"
                    />
                </div>
            </div>
        </div>
        <div class="header">
            <h5>Email Information</h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Email ID <span style="color: red">*</span></label>
                    <input
                        type="text"
                        pInputText
                        placeholder="Enter Email ID"
                        formControlName="emailId"
                    />
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Password <span style="color: red">*</span></label>
                    <input
                        type="password"
                        pInputText
                        placeholder="Enter Password"
                        formControlName="password"
                    />
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Cc</label>
                    <input
                        type="text"
                        pInputText
                        placeholder="Enter Email ID"
                        formControlName="emailCC"
                    />
                    <div>(Use comma(,) sign to enter multiple email id.)</div>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Bcc</label>
                    <input
                        type="text"
                        pInputText
                        placeholder="Enter Email ID"
                        formControlName="emailBCC"
                    />
                    <div>(Use comma(,) sign to enter multiple email id.)</div>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button
            type="button"
            pButton
            (click)="onDialogClose()"
            label="Cancel"
            class="p-button-secondary"
        ></button>
        <button
            type="button"
            pButton
            label="Save"
            (click)="save()"
            [disabled]="!smtpFb.valid"
        ></button>
    </p-footer>
</p-dialog>
